import { FileUploadModel } from './../../shared/models/file-upload.model';
import { SummerAppFieldsValidators } from './../../shared/enums/fields-validators.enum';
import { SelectListItemModel } from './../../shared/models/select-list-item.model';
import { SchoolsAutocompleteModel } from './../../shared/models/schools-autocomplete.model';
import { SummerAppFieldTypesEnum } from '../../shared/enums/field-types.enum';
import { StageQuestionsService } from '../stage-questions.service';
import { QuestionBaseModel } from '../../shared/models/question-base.model';
import { HttpClient } from '@angular/common/http';
import { DropdownQuestionModel } from '../../shared/models/dropdown-question.model';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Component, OnInit, Input } from '@angular/core';
import { StageRowModel } from './stage-row.model';
import { BaseFormValidation } from '../../shared/validators/base-form-validation';
import { SourceDateModel } from 'app/shared/models/sourcedate.model';
import { Observable } from 'rxjs/Observable';
import { AppSettings } from 'app/shared/app-settings';
import { SecurityService } from 'app/security/security.service';

import { CardConfirmService } from 'app/shared/services/card-confirm.service';
import { EnrollmentProgramsService } from 'app/shared/services/enrollment-programs.service';
import { AckFlagModel } from 'app/shared/models/AckFlag.model';
import { MatIconRegistry, MatStep, MatStepper, MatSnackBar } from '@angular/material';
import { PrintService } from 'app/shared/services/print.service';




@Component({
  selector: 'online-app-stage',
  templateUrl: './stage.component.html',
  styleUrls: ['./stage.component.scss']
})
export class StageComponent extends BaseFormValidation implements OnInit {

  protected isDocumentSet: boolean = false;

  protected FieldTypesEnumRef = SummerAppFieldTypesEnum;

  private dateFilter: string = "";

  private _securityService: SecurityService;
  private _cardConfirmService: CardConfirmService;
  private _programsService: EnrollmentProgramsService;
  private _ackFlagModel: AckFlagModel;
  private _questions: QuestionBaseModel<any>[];

  @Input() form: FormControl;

  @Input() set questions(val) {
    if (val) {
      this._questions = val.sort((a, b) => { return a.rowNumber - b.rowNumber });

      this.obfuscateCovidVaccinationStatusField(this._questions);

      let question = this._questions.find(i => i.fieldTypeName == SummerAppFieldTypesEnum.ResumeUpload);
      this.isDocumentSet = question ? question.isRequired : false;
      let dropdowns = this._questions.filter(i => i.fieldTypeName == SummerAppFieldTypesEnum.Dropdown);
      dropdowns.forEach((i) => {
        (<DropdownQuestionModel>i).getLookupOptions(this.http);
      })
    }
  };

  get questions() {
    return this._questions;
  }


  protected get rows(): number[] {
    return this._questions.reduce((prev: any[], c) => {
      if (prev.indexOf(c.rowNumber) < 0)
        prev.push(c.rowNumber);
      return prev;
    }, []);
  }

  constructor(private http: HttpClient, private secService: SecurityService, private cardConfirmService: CardConfirmService, 
    private programsService: EnrollmentProgramsService, private snackbar: MatSnackBar, private printService: PrintService) {
    super();
    this._securityService = secService;
    this._cardConfirmService = cardConfirmService;
    this._programsService = programsService;
    this._ackFlagModel = new AckFlagModel(0, false);
  }

  ngOnInit() {
  }

  onSubmit() {
  }



  protected getRowQuestions(rowNumber: number): QuestionBaseModel<any>[] {
    return this._questions.filter(i => i.rowNumber == rowNumber)
      .sort((a, b) => { return a.columnPlacement - b.columnPlacement });
  }

  protected isMatFormField(question: QuestionBaseModel<any>) {
    return question.fieldTypeName == SummerAppFieldTypesEnum.Numeric ||
      question.fieldTypeName == SummerAppFieldTypesEnum.Input ||
      question.fieldTypeName == SummerAppFieldTypesEnum.Dropdown ||
      question.fieldTypeName == SummerAppFieldTypesEnum.YesNoSelector ||
      question.fieldTypeName == SummerAppFieldTypesEnum.Date ||
      question.fieldTypeName == SummerAppFieldTypesEnum.SchoolsAutoComplete
  }

  private phoneMask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  private zipCodeMask = [/\d/, /\d/, /\d/, /\d/, /\d/];
  private ssnMask = [/\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  private middleInitialMask = [/[A-Za-z]/];


  protected getTextMask(question: QuestionBaseModel<any>) {
    if (question.validatorName == SummerAppFieldsValidators.PhoneNumber)
      return { mask: this.phoneMask }
    if (question.validatorName == SummerAppFieldsValidators.Zip)
      return { mask: this.zipCodeMask }
    if (question.validatorName == SummerAppFieldsValidators.SSN)
      return { mask: this.ssnMask }
    if (question.validatorName == SummerAppFieldsValidators.MiddleInitial) {
      return { mask: this.middleInitialMask }
    }
    return { mask: false };
  }

  protected obfuscateCovidVaccinationStatusField(questions: QuestionBaseModel<any>[]){
    // grab covid vaccination status field if present, hide value if user is not the one who filled the application, based on whether the login is a valid email

    var login = this._securityService.currentUserInfo.email;
    if (!/.+@.+\..+/.test(login)){
      var covidVaccinationStatus = questions.find(x => x.fieldName == "COVID_VACCINATION_STATUS");
      if (covidVaccinationStatus){
        covidVaccinationStatus['disabled'] = true;
        covidVaccinationStatus['options'].forEach(element => {
          element['name'] = "****";
        });
      }
    }
  }

  protected getDateFieldMaxDate(question: QuestionBaseModel<any>) {
    if (question.validatorName == SummerAppFieldsValidators.DateOfBirth) {
      //var dateOLD = new Date(this._securityService.currentUserInfo.sourceDate);
      var userProgram = this._programsService.getCurrentProgram();
      var checkUseCurrentDate = userProgram.useCurrentDate != null || userProgram != undefined || userProgram.useCurrentDate != undefined
       ? userProgram.useCurrentDate : false;

      var date: Date;
      if(checkUseCurrentDate){
        date = new Date();
      }
      else{
        date = new Date(userProgram.calculatedAgeSourceDate);
      }
      var minAge = userProgram.minimumAge ? userProgram.minimumAge : 12;
      date.setFullYear(date.getFullYear() - minAge);
      return date;
    }
    return null;
  }

  protected getDateFieldMinDate(question: QuestionBaseModel<any>) {
    if (question.validatorName == SummerAppFieldsValidators.DateOfBirth) {
      //var dateOLD = new Date(this._securityService.currentUserInfo.sourceDate);
      var userProgram = this._programsService.getCurrentProgram();
      var checkUseCurrentDate = userProgram.useCurrentDate != null ? userProgram.useCurrentDate : false;

      var date: Date;
      if(checkUseCurrentDate){
        date = new Date();
      }
      else{
        date = new Date(userProgram.calculatedAgeSourceDate);
      }
      var maxAge = userProgram.maximumAge ? userProgram.maximumAge : 24;
      date.setFullYear(date.getFullYear() - maxAge);
      return date;
    }
    return null;
  }

  protected youthDocChange(ev, question: FileUploadModel) {
    let fi = ev.srcElement;
    if (fi.files && fi.files[0]) {
      let fileToUpload = fi.files[0];
      question.file = fileToUpload;
      if (question.isRequired) {
        this.form.get(question.fieldName).clearValidators();
        this.form.get(question.fieldName).updateValueAndValidity();
        this.isDocumentSet = false;
      }
    } else {
      question.file = null;
      if (question.isRequired) {
        this.form.get(question.fieldName).setValidators([Validators.required]);
        this.form.get(question.fieldName).updateValueAndValidity();
        this.isDocumentSet = true;
      }
    }
  }

  myFilter = (d: Date): boolean => {
    if (this.dateFilter === "") {
      this.dateFilter = this.correctDate(d.toLocaleDateString());
    }
    let regexp = /^02\/(?:[01]\d|2\d)\/(?:19|20)(?:0[048]|[13579][26]|[2468][048])|(?:0[13578]|10|12)\/(?:[0-2]\d|3[01])\/(?:19|20)\d{2}|(?:0[469]|11)\/(?:[0-2]\d|30)\/(?:19|20)\d{2}|02\/(?:[0-1]\d|2[0-8])\/(?:19|20)\d{2}$/;
    if (regexp.test(this.dateFilter)) {
      return true;
    }
    else {
      return false;
    }

  }

  onChangeInput(e) {
    this.dateFilter = this.correctDate(e.srcElement.value);
  }

  onNameChange(e){
    e.target.value = e.target.value.trim()
  }

  onChangePaymentType(evt) {
    if (this._securityService.currentUserInfo.pyndexTransferredFlag || this._securityService.currentUserInfo.providerScreenedFlag) {
      this._securityService.toastr.error("Sorry, at this point in the application process you cannot make changes through the Online Application.");
      return;
    }
    if (evt.source.ngControl.name === "PAYMENT_TYPE_LUID") {
      var id: string = evt.source.id;
      var re = /DEBITCARD/gi;
      var str = evt.source.triggerValue.toUpperCase().replace(/\s+/g, '');
      if (str.search(re) != -1) {
        this._programsService.getProgramStatements(this._cardConfirmService.programAlias).subscribe((data) => {
          this._cardConfirmService.openCardConfirmDialog(evt.source.triggerValue, data.debitCardFeeAcknowledgement, () => {
            this._ackFlagModel.enrollmentId = this._securityService.currentUserInfo.id;
            this._ackFlagModel.flag = true;
            this._saveAckFlag(this._ackFlagModel).subscribe((res) => {
              if (res) {
                this.snackbar.open(`Saved successfully.`, "Success", {
                  duration: 2000,
                  verticalPosition: 'top'
                });
              }
            });
          },
            () => {
              this.form.get("PAYMENT_TYPE_LUID").setValue("");
            });
        });
      }
    }

  }

  checkNumericField() {

  }
  private _saveAckFlag(model: AckFlagModel): Observable<any> {
    return this.http.post(AppSettings.endpoints.enrollees.saveFlag, model, AppSettings.EMPTY_REQUEST_OPTIONS).map(res => { return true });
  }

  private correctDate(date: string): string {
    var temp = date.split('/');
    if (temp === undefined) {
      temp = date.split('.');
    }
    if (temp[0] !== undefined && temp[1] !== undefined && temp[0].length === 1 && temp[1].length > 1) {
      return "0" + temp[0] + "/" + temp[1] + "/" + temp[2];
    }
    else if (temp[0] !== undefined && temp[1] !== undefined && temp[0].length === 1 && temp[1].length === 1) {
      return "0" + temp[0] + "/0" + temp[1] + "/" + temp[2]
    }
    else if (temp[0] !== undefined && temp[1] !== undefined && temp[0].length > 1 && temp[1].length === 1) {
      return temp[0] + "/0" + temp[1] + "/" + temp[2]
    }
    else {
      return date;
    }

  }
}



// WEBPACK FOOTER //
// ./src/app/stages/stage/stage.component.ts